const Card = ({ 
  children, 
  className = '', 
  hover = true,
  padding = 'md',
  glow = false,
  ...props 
}) => {
  const paddingStyles = {
    none: '',
    sm: 'p-5 sm:p-6',
    md: 'p-6 sm:p-8',
    lg: 'p-8 sm:p-10 lg:p-12',
  }
  
  const hoverStyles = hover 
    ? 'hover:shadow-card-hover hover:-translate-y-1 hover:border-gray-200/100 dark:hover:border-gray-600/100 transition-all duration-300 ease-out' 
    : ''
  
  const glowStyles = glow 
    ? 'shadow-card-glow border-accent/20 dark:border-accent/30' 
    : ''
  
  return (
    <div
      className={`
        bg-white dark:bg-gray-800 
        border border-gray-200/80 dark:border-gray-700/80 
        rounded-3xl 
        shadow-card dark:shadow-[0_8px_30px_-6px_rgba(0,0,0,0.4)]
        ${paddingStyles[padding]}
        ${hoverStyles}
        ${glowStyles}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  )
}

export default Card
